import React from 'react'
import './styles/Banner.css'
export function Banner() {
    return (
        <div className='Banner'>
            <h1>
                Spend less travel more with EcoScoot!
            </h1>
            <p>
                Available <span>24/7</span> at your service
            </p>
        </div>
    )
}
